/**
 * Images des articles sur les écrans du téléphone (carte du serveur, panier client).
 *
 * La photo d'un article voyage dans le catalogue Scan & Go sous forme d'un chemin
 * (« /articles/<société>/<fichier>.jpg ») ; l'image elle-même est servie par
 * l'adresse des fichiers publics de l'API.
 *
 * L'affichage avec / sans images est un choix propre à l'appareil : utile sur un
 * réseau lent ou un petit écran. Affichées par défaut.
 */

const CLE = "sg_images_v1";

/** Les images sont-elles affichées sur cet appareil ? */
export function imagesActives() {
    try {
        return localStorage.getItem(CLE) !== "0";
    } catch (e) {
        return true; // stockage indisponible (navigation privée) : réglage par défaut
    }
}

/** Mémorise le choix et le renvoie. */
export function reglerImages(actives) {
    try { localStorage.setItem(CLE, actives ? "1" : "0"); } catch (e) { /* non mémorisé */ }
    return !!actives;
}

/** Adresse complète d'une photo d'article, ou "" s'il n'y en a pas. */
export function urlPhoto(chemin) {
    const c = String(chemin || "").trim();
    return c ? String(process.env.VUE_APP_API_URL_FILE || "") + c : "";
}
